import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  makeStyles,
} from '@material-ui/core';
import { Button } from '@saviynt/design-system';
import PropTypes from 'prop-types';

const useStyles = makeStyles({
  content: {
    padding: '1rem 0',
  },
});

function WorkGroupForm({ isOpen, onClose, title, data, onConfirm }) {
  const classes = useStyles();
  const [userGroup, setUserGroup] = useState('');
  const [userGroupDescription, setUserGroupDescription] = useState('');

  useEffect(() => {
    if (data) {
      try {
        const workGroupData = typeof data === 'string' ? JSON.parse(data) : data;
        setUserGroup(workGroupData.usergroup || '');
        setUserGroupDescription(workGroupData.user_groupdescription || '');
      } catch (error) {
        setUserGroup('');
        setUserGroupDescription('');
      }
    }
  }, [data]);

  const handleConfirm = () => {
    const updatedConfig = {
      ...data,
      usergroup: userGroup,
      user_groupdescription: userGroupDescription,
    };
    onConfirm(updatedConfig);
  };

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Work Group Configuration - {title}</DialogTitle>
      <DialogContent>
        <div className={classes.content}>
          <TextField
            label="User group"
            value={userGroup}
            onChange={(e) => setUserGroup(e.target.value)}
            fullWidth
            margin="normal"
            variant="outlined"
          />
          <TextField
            label="User group description"
            value={userGroupDescription}
            onChange={(e) => setUserGroupDescription(e.target.value)}
            fullWidth
            margin="normal"
            variant="outlined"
            multiline
            rows={3}
          />
        </div>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="contained" color="primary" onClick={handleConfirm}>
          Save Configuration
        </Button>
      </DialogActions>
    </Dialog>
  );
}

WorkGroupForm.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  data: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onConfirm: PropTypes.func.isRequired,
};

WorkGroupForm.defaultProps = {
  data: null,
};

export default WorkGroupForm;
